import entityManager from '../lib/entityManager';
import { TUNE } from '../lib/config';
import { TakesTurns, ActorStats, PlayerControlled, PredictedState, WantsToAct } from '../components';

/**
 * Predicts the turn order of actors and their energy state relative to the player's next turn.
 */
export default class TurnPredictionSystem {
  update() {
    this.predictActorStates();
  }

  /**
   * Predicts the energy and number of actions for each actor until the player's next turn.
   * @private
   */
  predictActorStates() {
    // Cleanup old prediction components
    const oldPredictedStateEntities = entityManager.query([PredictedState]);
    oldPredictedStateEntities.forEach(entity => entity.removeComponent(PredictedState));

    const actors = entityManager.query([TakesTurns, ActorStats]);
    if (actors.length === 0) return;

    const player = entityManager.query([PlayerControlled, TakesTurns, ActorStats])[0];
    if (!player) return; // Cannot predict without a player

    // Calculate the time horizon: ticks until the player can act.
    const playerTakesTurns = player.getComponent(TakesTurns);
    const playerStats = player.getComponent(ActorStats);
    
    // Start with the player's actual current energy.
    let playerEnergyForCalc = playerTakesTurns.energy;

    // If the player is waiting to act, their current turn is already "accounted for".
    // We need to predict based on the energy they'll have *after* this turn.
    if (player.hasComponent(WantsToAct)) {
      playerEnergyForCalc -= TUNE.ACTION_COST;
    }

    const energyNeededByPlayer = TUNE.ACTION_COST - playerEnergyForCalc;
    const ticksUntilPlayerAction = energyNeededByPlayer > 0
      ? Math.ceil(energyNeededByPlayer / playerStats.speed)
      : 0;

    // For each actor, project their total energy at the time horizon.
    actors.forEach(entity => {
      const takesTurns = entity.getComponent(TakesTurns);
      const stats = entity.getComponent(ActorStats);

      const totalPredictedEnergy = takesTurns.energy + (stats.speed * ticksUntilPlayerAction);

      // Attach the prediction component with the single raw energy value.
      entity.addComponent(PredictedState, new PredictedState(totalPredictedEnergy));
    });
  }
}
